export const CONFIG_REQUEST_START = "CONFIG_REQUEST_START";
export const CONFIG_REQUEST_SUCCESS = "CONFIG_REQUEST_SUCCESS";
export const CONFIG_REQUEST_FAIL = "CONFIG_REQUEST_FAIL";

export const FETCH_MODEL_START = "FETCH_MODEL_START";
export const FETCH_MODEL_SUCCESS = "FETCH_MODEL_SUCCESS";
export const FETCH_MODEL_FAIL = "FETCH_MODEL_FAIL";

export const FETCH_MENU_START = "FETCH_MENU_START";
export const FETCH_MENU_SUCCESS = "FETCH_MENU_SUCCESS";
export const FETCH_MENU_FAIL = "FETCH_MENU_FAIL";
